import React, { useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { getConfig } from '../../utils/configReader';
import { fetchUserinfoWithRetry } from '../../utils/getUserinfo';
import { NavigationBar } from '../NavigationBar/NavigationBar';
import CookieBanner from '../NavigationBar/Banner';
import { Login } from '../NavigationBar/Login';
import Register from '../NavigationBar/Register';
import TailoredSearch from '../ESGFSearch/Search/TailoredSearch';
import { OPENID } from './ApplicationConfig';
import { LandingPage } from '../NavigationBar/LandingPage/LandingPage';
import { C4IPrivacyNotice } from '../NavigationBar/PrivacyNotice/PrivacyNotice';
import { C4IUserGuide, SwirrlUserGuide, } from '../NavigationBar/Documentation/UserGuide';
import { UserProvider, UserCtx } from './ApplicationContext';
import { ProjectSelector } from '../NavigationBar/ProjectSelector/ProjectSelector';
require('./App.css');
const config = getConfig();
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const classes = {
    main: {
        fontSize: '1.0rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: 1.334,
        letterSpacing: '0em',
        padding: '20px',
        backgroundColor: '#fafafa',
    },
    mainPaper: {
        padding: '20px',
    },
};
const theme = createTheme({
    palette: {
        primary: {
            main: '#3f51b5',
        },
    },
});
const Main = () => {
    const { user, setUser } = useContext(UserCtx);
    React.useEffect(() => {
        fetchUserinfoWithRetry(OPENID.userinfo_endpoint, {
            method: 'GET',
            credentials: 'include',
        })
            .then((res) => (res && res.status === 200 ? res.json() : null))
            .then((res) => setUser(res))
            .catch((err) => console.error(err));
    }, []);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(BrowserRouter, { basename: config.frontendPath },
            React.createElement("div", { className: 'MainWrapper' },
                React.createElement("div", { className: 'MainNavBar' },
                    React.createElement(NavigationBar, { user: user })),
                React.createElement("div", { className: 'MainContent' },
                    React.createElement(Routes, null,
                        React.createElement(Route, { path: '/', element: React.createElement("div", { style: classes.main },
                                React.createElement(LandingPage, { user: user })) }),
                        React.createElement(Route, { path: 'project', element: React.createElement(ProjectSelector, null) }),
                        React.createElement(Route, { path: 'search', element: React.createElement(TailoredSearch, { user: user }) }),
                        React.createElement(Route, { path: 'login', element: React.createElement("div", { style: classes.main },
                                React.createElement(Login, null)) }),
                        React.createElement(Route, { path: 'register', element: React.createElement("div", { style: classes.main },
                                React.createElement(Register, null)) }),
                        React.createElement(Route, { path: 'helpC4I', element: React.createElement("div", { style: classes.main },
                                React.createElement(C4IUserGuide, null)) }),
                        React.createElement(Route, { path: 'helpSwirrl', element: React.createElement("div", { style: classes.main },
                                React.createElement(SwirrlUserGuide, null)) }),
                        React.createElement(Route, { path: 'privacy-notice', element: React.createElement("div", { style: classes.main },
                                React.createElement(C4IPrivacyNotice, null)) })),
                    React.createElement(CookieBanner, null))))));
};
const App = () => {
    useEffect(() => {
        var _a;
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,no-multi-assign
        const _mtm = (window._mtm = window._mtm || []);
        _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
        const d = document;
        const g = d.createElement('script');
        const s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = config.matomoUrl;
        (_a = s.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(g, s);
    }, []);
    return (React.createElement("div", { className: 'viewer_wrapper' },
        React.createElement("div", { className: 'viewer_header' },
            React.createElement("div", { className: 'c4i-header-logo' },
                React.createElement("a", { href: '#' },
                    React.createElement("img", { src: './images/IS-ENES3_logo_small.png', alt: 'is-enes logo' }))),
            React.createElement("div", { className: 'c4i-header-text' }, "Exploring climate model data")),
        React.createElement("div", { className: 'viewer_sidebar' }, "Sidebar"),
        React.createElement("div", { className: 'viewer_content' },
            React.createElement(UserProvider, null,
                React.createElement(Main, null))),
        React.createElement("div", { className: 'viewer_footer' },
            React.createElement("img", { className: 'c4i-footer-euflag', alt: '', src: './images/euflag.png' }),
            React.createElement("span", { className: 'c4i-footer-text' }, "This project has received funding from the European Union\u2019s Horizon 2020 research and innovation programme under grant agreement No 824084"))));
};
export default App;
